module.exports = __webpack_public_path__ + "static/media/helpdesk-icon.3d5a579f.png";